import { SizeEnum } from './size-enum'

export type ScaleKey =
  | 'lp1'
  | 'lp2'
  | 'lp8'
  | 'mn2'
  | 'mj2'
  | 'mn3'
  | 'mj3'
  | 'p4'
  | 'a4'
  | 'p5'
  | 'gr'

export type Size = keyof typeof SizeEnum

export function isSizeKey(key: string): key is Size {
  return Object.keys(SizeEnum).includes(key)
}

export * from './theme-keys'
